export function LoadingScreenComponent() {
	return (
		<div className="flex min-h-svh items-center justify-center bg-paper">
			<span
				className="size-9 animate-spin rounded-full border-[3px] border-brand-soft border-t-brand"
				aria-hidden="true"
			/>
		</div>
	);
}
